import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';

import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import Button from 'Components/UI/Button';
import { advisorNotificationCenterPath } from 'Consts/advisorUris';
import PropTypes from 'prop-types';
import NotificationList from '../NotificationList';

const CLIENT_ROLE = 'client';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(1, 0),
  },
  badge: {
    fontSize: '10px',
    height: '16px',
    minWidth: '16px',
    padding: '0 4px',
  },
  markAllButton: {
    margin: theme.spacing(1),
  },
  title: {
    color: theme.palette.primary.main,
    padding: theme.spacing(1, 3),
  },
}));

const PreviewContent = ({
  pollingNotifications,
  markAllPollingNotificationsRead,
  markPollingNotificationRead,
  userRole,
}) => {
  const classes = useStyles();
  const isAgent = !(userRole || [CLIENT_ROLE]).includes(CLIENT_ROLE);
  const { logEvent, rootNodeProps } = useEventTrackingLogEvent({
    nodeName: 'Notifications Popover',
  });

  return (
    <Paper
      className={classes.root}
      elevation={5}
      {...rootNodeProps}
    >
      {pollingNotifications.length === 0 ? (
        <Typography className={classes.title} variant="h5">
          {'No notifications'}
        </Typography>
      ) : (
        <>
          <Button
            className={classes.markAllButton}
            variant="text"
            color="primary"
            onClick={markAllPollingNotificationsRead}
          >
            {'Mark these as read'}
          </Button>
          <NotificationList
            notifications={pollingNotifications}
            updateNotification={markPollingNotificationRead}
            isAgent={isAgent}
          />
          {isAgent && (
            <Button
              fullWidth
              variant="text"
              color="primary"
              component={Link}
              onClick={() => {
                logEvent('Click see all');
              }}
              to={advisorNotificationCenterPath}
            >
              {'See All'}
            </Button>
          )}
        </>
      )}
    </Paper>
  );
};

export default PreviewContent;

PreviewContent.propTypes = {
  pollingNotifications: PropTypes.array.isRequired,
  markAllPollingNotificationsRead: PropTypes.func.isRequired,
  markPollingNotificationRead: PropTypes.func.isRequired,
  userRole: PropTypes.array.isRequired,
};
